import React from "react";
import { CtaButton } from "@/components/CtaButton";
import { SITE } from "@/constants/testIds";

export const HomePractitionerSection = ({ practitioner }) => (
    <section
        data-testid={SITE.homePractitioner}
        className="py-14 sm:py-20 bg-sand/40 bg-grain"
    >
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-5">
                    <div className="aspect-[4/5] rounded-3xl overflow-hidden border border-border/70 shadow-[0_18px_46px_rgba(30,35,32,0.16)] bg-sand">
                        {practitioner?.portrait_url && (
                            <img
                                src={practitioner.portrait_url}
                                alt={practitioner.name}
                                className="h-full w-full object-cover"
                            />
                        )}
                    </div>
                </div>
                <div className="lg:col-span-7">
                    <p className="font-accent text-xs text-terracotta">
                        MEET YOUR PRACTITIONER
                    </p>
                    <h2 className="mt-2 font-display text-3xl sm:text-4xl text-moss leading-tight">
                        {practitioner?.name || "Riley Ann"}
                    </h2>
                    <p className="mt-1 text-foreground/70">
                        {practitioner?.title}{" "}
                        <span className="text-foreground/55">
                            {practitioner?.credential_year}
                        </span>
                    </p>
                    <p className="mt-5 max-w-prose text-foreground/85 leading-relaxed">
                        {practitioner?.story}
                    </p>
                    <p className="mt-4 max-w-prose text-foreground/80 leading-relaxed">
                        {practitioner?.approach}
                    </p>
                    <div className="mt-6">
                        <CtaButton to="/about" variant="secondary">
                            Read Riley’s full story
                        </CtaButton>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default HomePractitionerSection;
